jQuery(document).ready(function () {

  function getStickyImg() {
    return document.querySelector('#yvProductStickyBar .product-view-img img');
  }

  function updateStickyImage() {
    var stickyImg = getStickyImg();
    if (!stickyImg) return;
    // Get the currently selected slide image from Flickity
    var activeImg = document.querySelector('[data-flickity-product-slider] .is-selected img, [data-flickity-product-slider] .flickity-selected img');
    if (!activeImg) {
      // Fallback: first visible image in product gallery
      activeImg = document.querySelector('.yv-product-slider-item.is-selected img, .yv-product-media-item.is-selected img');
    }
    if (!activeImg) {
      // Last fallback: first product image
      activeImg = document.querySelector('.yv-product-slider-item img, .yv-product-media-item img');
    }
    if (activeImg && activeImg.src) {
      stickyImg.src = activeImg.src;
    }
  }

  function updateVariantLabel() {
    var parts = [];
    for (var i = 1; i <= 3; i++) {
      var checked = document.querySelector('.productOption[name="option-' + i + '"]:checked');
      if (checked) parts.push(checked.value);
    }
    var label = document.getElementById('sticky-variant-label');
    if (label && parts.length > 0) {
      label.textContent = parts.join(' / ');
    }
  }

  function enableStickyBtn() {
    var stickyBtn = document.querySelector('.Sd_addProductSticky');
    if (stickyBtn) {
      var formId = stickyBtn.getAttribute('form');
      if (formId) {
        var idInput = document.querySelector('#' + formId + ' input[name="id"]');
        if (idInput) idInput.disabled = false;
      }
      stickyBtn.disabled = false;
      stickyBtn.style.pointerEvents = 'auto';
      stickyBtn.style.opacity = '1';
    }
  }

  function syncSticky() {
    updateVariantLabel();
    updateStickyImage();
    enableStickyBtn();
  }

  setTimeout(syncSticky, 400);
  setTimeout(syncSticky, 1000);
  setTimeout(syncSticky, 2000);

  // When user picks a variant
  jQuery(document).on('change click', '.productOption', function () {
    // Wait for Flickity to animate to new slide
    setTimeout(syncSticky, 400);
  });

  // Watch for sticky bar becoming visible
  var stickyBar = document.getElementById('yvProductStickyBar');
  if (stickyBar) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && stickyBar.classList.contains('show')) {
          syncSticky();
        }
      });
    }).observe(stickyBar, { attributes: true });
  }

  // Sticky add-to-cart: the theme's own cart-ajax.js already handles
  // .Sd_addProductSticky and resolves the form via the form= attribute.
  // Forwarding the click here fired a second /cart/add, so every tap added
  // quantity 2. All that's still needed is making the variant id submittable;
  // mousedown/touchstart run before click, so this lands first.
  jQuery(document).on('mousedown touchstart', '.Sd_addProductSticky', function () {
    var formId = jQuery(this).attr('form');
    if (formId) {
      jQuery('#' + formId).find('input[name="id"]').prop('disabled', false);
    }
  });

});